import { t } from "@lingui/macro";
import { List, SquaresFour } from "@phosphor-icons/react";
import { ScrollArea, Tabs, TabsContent, TabsList, TabsTrigger } from "@reactive-resume/ui";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

import { useResumesViewStore, ResumesViewMode } from "@/client/stores/resumes-view";

import { GridView } from "./_layouts/grid";
import { ListView } from "./_layouts/list";

export const ResumesPage = () => {
  const { resumesViewMode, setViewMode } = useResumesViewStore();

  return (
    <>
      <Helmet>
        <title>
          {t`Resumes`} - {t`Resumotion`}
        </title>
      </Helmet>

      <Tabs
        value={resumesViewMode}
        className="space-y-4"
        onValueChange={(value) => {
          setViewMode(value as ResumesViewMode);
        }}
      >
        <div className="flex items-center justify-between">
          <motion.h1
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-4xl font-bold tracking-tight"
          >
            {t`Resumes`}
          </motion.h1>

          <TabsList>
            <TabsTrigger value={ResumesViewMode.Grid} className="size-8 p-0 sm:h-8 sm:w-auto sm:px-4">
              <SquaresFour />
            </TabsTrigger>
            <TabsTrigger value={ResumesViewMode.List} className="size-8 p-0 sm:h-8 sm:w-auto sm:px-4">
              <List />
            </TabsTrigger>
          </TabsList>
        </div>

        <ScrollArea
          allowOverflow
          className="h-[calc(100vh-140px)] overflow-visible lg:h-[calc(100vh-88px)]"
        >
          <TabsContent value="grid">
            <GridView />
          </TabsContent>
          <TabsContent value="list">
            <ListView />
          </TabsContent>
        </ScrollArea>
      </Tabs>
    </>
  );
};
